import React from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import BlobMorpher from '../../BlobMorpher';
import className from '../../../utils/className';
import styles from './stepsArtwork.css';

const StepsArtwork = () => {
  // Colors to map over
  const colors = [
    {
      color: 'green',
      idx: 'One',
    },
    {
      color: 'maroon',
      idx: 'Two',
    },
    {
      color: 'purpleBlue',
      idx: 'Three',
    },
    {
      color: 'yellow',
      idx: 'Four',
    },
    {
      color: 'red',
      idx: 'Five',
    },
  ];

  // Generates random durations, from 1000 - 5000
  const durations = colors.map(() => (Math.floor(Math.random() * Math.floor(4)) + 1) * 1000);

  const isTouch = isMobile || isTablet;

  return (
    <div {...className(styles.wrapper, isTouch && styles.touch)}>
      {colors.map(({ color, idx }, i) => (
        <div className={styles[`artBlob${idx}`]} key={idx}>
          <BlobMorpher color={`var(--${color})`} duration={durations[i]} />
        </div>
      ))}
    </div>
  );
};

export default StepsArtwork;
